import React, { Component, useState } from 'react'
import ReadMoreReact from 'read-more-react';
import slider from '../../assets/images/slide.png'
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { boolean } from '@storybook/addon-knobs';


import Vid1 from "../../assets/images/Vid1.png"
import Vid2 from "../../assets/images/Vid2.png"
import on from "../../assets/images/on.svg"
import off from "../../assets/images/off.svg"
import hendray from "../../assets/images/hendray.png"
import clockIcon from "../../assets/images/clockIcon.png"

class AboutHendrayFinvest extends Component {

    render() {
        const tooglesGroupId = 'Toggles';

        const getConfigurableProps = () => ({
            showArrows: boolean('showArrows', false, tooglesGroupId),
            showStatus: boolean('showStatus', false, tooglesGroupId),
            showThumbs: boolean('showThumbs', false, tooglesGroupId),
        })
        return (
            <>
                <div className="whatwedo">
                    <h1 className="main-color">WHAT WE DO</h1>
                    <div className="statement">
                        {/* We are a group of innovative and unique forex traders based in Africa; we trade everything represented on a chart. We evangelize the concepts of being participants in the global financial market and provide educational resources to interested individuals- teaching them how to be consistent and independent profitable traders.
                        <br /><br />
                        We are building a platform for the long term in a bid to enable an ecosystem that will set the standard of changing lives and enabling generations to come.
                        <br /><br />
                        <ReadMoreReact
                        text={`
                            We are passionate about the business of the foreign exchange market hence, we have laid down a comprehensive curriculum designed to effectively nurture and educate interested individuals to be proficient and sound as long as trading is concerned. ${"\n"} As consistency is synonymous with this business, we have thoroughly invested our time into discipline, teamwork, and patience- a virtue we also imbibe in our students, audience, and community ${"\n"} At the same time, we have a common feature - focus on results, yes, we go to the goal in different ways, yes, we use quite different methods to work in the investment market and Forex, but the focal point of all efforts is for the greatest efficiency which is the basis of our competencies. \n No complexities, no merry-go-round, good organization, outstanding education, a visionary team, good technology, excellent mentors, supportive community, and many more. Every day, we try as much as possible to keep up the energy of these virtues and qualities and even more- we are everything you could ask for. Regardless of whatever category of traders you fall in, join us today, and experience a turn-around in your trading journey.
                            `}
                        min={200}
                        ideal={250}
                        max={300}
                        readMoreText={"read more"}
                        /> */}
                        <div className="statementFlex">
                            <div className="statementContent right2">
                                We are a group of innovative and unique forex traders based in Africa; we trade everything represented on a chart. We evangelize the concepts of being participants in the global financial market and provide educational resources to interested individuals- teaching them how to be consistent and independent profitable traders. Forex trading works, big time! The failures of individuals who have ventured into this business can be traced back to the complexities of the model of training and education they got. 
                                <br /><br />
                                We are building a platform for the long term in a bid to enable an ecosystem that will set the standard of changing lives and enabling generations to come.
                                <br /><br />
                                We are passionate about the business of the foreign exchange market hence, we have laid down a comprehensive curriculum designed to effectively nurture and educate interested individuals to be proficient and very sound, as long as trading is concerned.
                            </div>
                            <div className="statementContent">
                            As consistency is synonymous with this business, we have thoroughly invested our time into discipline, teamwork, and patience- a virtue we also imbibe in our students, audience, and community.
                            <br /><br />
                            At the same time, we have a common feature - focus on results, yes, we go to the goal in different ways, yes, we use quite different methods to work in the investment market and Forex, but the focal point of all efforts is for the greatest efficiency which is the basis of our competencies.
                            <br /><br />
                            No complexities, no merry-go-round, good organization, outstanding education, a visionary team, good technology, excellent mentors, supportive community, and many more. Every day, we try as much as possible to keep up the energy of these virtues and qualities and even more- we are everything you could ask for. Regardless of whatever category of traders you fall in, join us today, and experience a turn-around in your trading journey. 
                            </div>
                        </div>
                    </div>
                </div>
                <div className="whatwedo-gallery">
                    <div className="">
                        <Carousel autoPlay {...getConfigurableProps()} >
                            <div className="aboutSlide">
                                <img src={slider} alt="HendrayFinvest workspace" className="yeee"/>
                            </div>
                            <div className="aboutSlide">
                                <img src={slider} alt="HendrayFinvest workspace" className="yeee"/>
                            </div>
                            <div className="aboutSlide">
                                <img src={slider} alt="HendrayFinvest workspace" className="yeee"/>
                            </div>
                        </Carousel>
                    </div>
                </div>
                <div className="vm">
                    <div className="vm-statement">
                        <div className="vm-text">
                            <div className="vm-head leftJust">
                                <h1 className="head-2">THE VISION </h1>
                            </div>
                            <h6>
                                
                                <ReadMoreReact
                                text={`Our vision is to build and expand an ecosystem of financial freedom, stability, and possibilities for individuals and organizations that dare to take risks. Through our hunger for growth which leads to our constant research and development, commitment to values, and working with excellent individuals who will see and run with the vision, Hendray Finvest will become one of the leading players of the foreign exchange business in Africa, and the world at large. Our vision reflects the cornerstone of our values: Integrity, service, teamwork & excellence.`}
                                min={80}
                                ideal={120}
                                max={300}
                                readMoreText={"read more"}
                                />
                            </h6>
                        </div>
                        <div className="vm-video">
                            <img src={Vid1} alt="Statement video" />
                        </div>
                    </div>
                </div>
                <div className="vm">
                    <div className="vm-statement vm-statement2">
                        <div className="vm-video">
                            <img src={Vid1} alt="Statement video" />
                        </div>
                        <div className="vm-text">
                            <div className="vm-head">
                                <h1 className="head-2">MISSION</h1>
                            </div>
                            <h6>
                                 
                                <ReadMoreReact
                                text={`Our mission is to provide professional and trusted services concerning the forex business to assist organizations and individuals. With the determination to see through our goals and vision, we hope to make it transcend generations, gives the necessary push to change some rhetorics of forex trading being an unrealistic or fraudulent business in some part of Africa.
                                We are also poised to position our brand to be the best in the continent and also to be one at the top in the world.`}
                                min={80}
                                ideal={120}
                                max={300}
                                readMoreText={"read more"}
                                />
                            </h6>
                        </div>
                    </div>
                </div>
                {/* <div className="learning-curve">
                    <div>
                        <h1>OUR LEARNING CURVE</h1>
                        <h6>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                    </h6>
                    </div>
                </div> */}
                {/* <div className="learning-standards">
                    <div>
                        <h4>Educational <br /> Standards</h4>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        </p>
                    </div>
                    <div>
                        <h4>Excellent <br /> Educators</h4>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        </p>
                    </div>
                    <div>
                        <h4>Excellent <br /> Educators</h4>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        </p>
                    </div>
                </div> */}
                {/* <div className="ls-width">
                    <div className="learning-sessions">
                        <div className="ls-text">
                            <h2>Join daily & weekly live <br /> sessions with our educators.
                        </h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                        </p>
                        </div>
                        <div className="ls-card">
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="toggleField vm">
                    <div className="toggleTitle">
                        <h1 className="head-2">VALUES</h1>
                    </div>
                    <div className="toggleSide2">
                        <div className="toggleFlex2 mra">
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>+VE VIBES</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={off} className="toggleText"/>
                                <h4>EXCUSES</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>FOCUS</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>DISCIPLINE</h4>
                            </div>
                        </div>
                        <div className="toggleFlex2">
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>INTEGRITY</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>CONSISTENCY</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={on} className="toggleText"/>
                                <h4>TEAM-WORK</h4>
                            </div>
                            <div className="toggleContent2">
                                <img src={off} className="toggleText"/>
                                <h4>-VE VIBES</h4>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="lc-width">
                    <div className="lc-last">
                        <div>
                            <img src={Vid2} />
                        </div>
                        <div className="lc-last-text">
                            <h2>
                                Some members of our community have something to say.
                            </h2>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default AboutHendrayFinvest;